import { memo } from 'react';

import { merge } from '@/components';
import { Autosave, Flex, Heading, Text } from '@/components/core';
import { TriggerLogo } from '@/components/logos';
import { useAutoUpdateAction } from '@/hooks/api';
import { useTriggerStore } from '@/store';
import { DivProps, formatDate, OmitChildren } from '@/utils';

export type TriggerPanelHeaderProps = OmitChildren<DivProps> & {
  actionId: string;
};

const ITriggerPanelHeader = ({ className, actionId, ...rest }: TriggerPanelHeaderProps) => {
  const action = useTriggerStore((state) => state.action);
  const { isPending, isSuccess, error } = useAutoUpdateAction(
    1000,
    { actionId },
    {
      config: action.config,
      enabled: action.enabled,
      functionId: action.functionId,
      metadata: action.metadata,
      name: action.name,
    }
  );

  return (
    <Flex className={merge('items-center gap-2', className)} {...rest}>
      <TriggerLogo className="rounded-lg" size="xl" functionId={action.functionId} />
      <Flex col>
        <Heading size="lg">{action.name}</Heading>
        <Text variant="tertiary">Last updated: {formatDate(action.updatedTime ?? action.createdTime)}</Text>
      </Flex>

      <div className="grow" />

      <Autosave isPending={isPending} isSuccess={isSuccess} error={error} />
    </Flex>
  );
};

export const TriggerPanelHeader = memo(ITriggerPanelHeader) as typeof ITriggerPanelHeader;
